// import u from "./utils";

import MAP_STYLES from "./mapStyles";

function icon(color, isActive) {
	return {
		path: " M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0",
		scale: isActive ? 0.15 : 0.08,
		strokeWeight: 0,
		fillOpacity: 1,
		fillColor: color,
		anchor: isActive
			? new google.maps.Point(91, 91)
			: new google.maps.Point(85, 85)
	};
}

function iconSelect(type, isActive) {
	switch (type) {
		case "venue":
			return icon("#00aeef", isActive);
		case "info_point":
			return icon("#fcaf17", isActive);
		case "street_art":
			return icon("#3b247d", isActive);
		case "festival_wall":
			return icon("#e61c6b", isActive);
	}
}

export default function initMapOverlay() {
	if (!document.querySelector("[data-map-overlay]") || !window.google) {
		return;
	}
	return new MapOverlay();
}

class MapOverlay {
	constructor() {
		this.$mapOverlay = document.querySelector("[data-map-overlay]");
		this.$canvas = this.$mapOverlay.querySelector("[data-interactive-map]");
		this.$artworks = this.$mapOverlay.querySelectorAll("[data-artwork-latlng]");
		this.mapCenter = new google.maps.LatLng([-42.0800922], [145.5557205]);
		this.mapZoom = window.screen.width <= 768 ? 15 : 16.5;
		this.markers = [];
		this.bounds = new google.maps.LatLngBounds();
		this.$closeArtworkDetails = this.$mapOverlay.querySelector(
			"[data-artwork-close]"
		);
		this.$details = this.$mapOverlay.querySelector("[data-map-details]");

		// cater screen size to deal with mobile address bars
		// plus orientation changes between small/med size screens (e.g. iPad)
		if (document.body.scrollWidth <= 768) {
			this.reloadMap();
		}
		window.addEventListener("orientationchange", _ => {
			this.reloadMap();
		});

		//google maps requires object for latlng, not string
		this.artworks = Array.prototype.map.call(this.$artworks, $artwork => {
			let latLng = $artwork.dataset.artworkLatlng.replace(" ", "");
			return {
				type: $artwork.dataset.artworkType,
				latLng: latLng.split(","),
				id: $artwork.dataset.artworkId
			};
		});

		this.map = new google.maps.Map(this.$canvas, {
			center: this.mapCenter,
			zoom: this.mapZoom,
			disableDefaultUI: true,
			gestureHandling: "greedy",
			zoomControl: false,
			styles: MAP_STYLES
		});

		//markers should only need to be generated once (on map initialisation)
		this.artworks.forEach((l, i) => {
			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(l.latLng[0], l.latLng[1]),
				map: this.map,
				icon: iconSelect(l.type, false)
			});
			marker.type = l.type;
			marker.location = l.latLng;
			marker.artworkId = l.id;

			this.bounds.extend(marker.position);
			this.map.fitBounds(this.bounds);
			this.markers.push(marker);

			if (i === this.artworks.length - 1) {
				//event based, so can't get center until this happens
				google.maps.event.addListenerOnce(this.map, "idle", e => {
					//only do this once all markers have been initialised
					this.map.setZoom(this.mapZoom);
					offsetCenter(this.map, this.map.getCenter(), 0, 0);
				});
			}
		});
	}

	//because we detect mobile screen size with js, we need to force a refresh when orientation changes (e.g. iPad)
	reloadMap() {
		if (document.body.scrollWidth <= 768) {
			const mapHeight = window.innerHeight;
			this.$canvas.style.position = "relative";
			this.$canvas.style.height = mapHeight / 2 + "px";
		} else {
			this.$canvas.style.height = "100%";
			this.$canvas.style.position = "absolute";
			this.$mapOverlay.display = "flex";
			this.$mapOverlay.flexdirection = "row-reverse";
		}
	}

	//set up the event listeners when the page loads (cannot be affected by page transitions)
	setupMapSpecficTriggers() {
		const $mapCloseTriggers = this.$mapOverlay.querySelectorAll(
			"[data-map-close]"
		);
		if ($mapCloseTriggers) {
			$mapCloseTriggers.forEach($mapCloseTrigger => {
				$mapCloseTrigger.addEventListener("click", e => {
					e.preventDefault();
					this.close();
				});
			});
		}

		//add event listeners for markers and venues
		this.markers.forEach(m => {
			google.maps.event.addListener(m, "click", _ => {
				this.selectArtwork(m.artworkId);
			});
		});

		this.$artworks.forEach($artwork => {
			$artwork.addEventListener("click", e => {
				this.selectArtwork($artwork.dataset.id);
			});
		});

		this.$closeArtworkDetails.addEventListener("click", e => {
			this.clearVenueEvents();
			this.backToVenueList();
			e.preventDefault();
		});
	}

	//triggers that are set on each page (not in base.html) need to be instantiated each page transition
	setupMapOpenTriggers() {
		const $mapOpenTriggers = document.querySelectorAll("[data-map-trigger]");
		if ($mapOpenTriggers) {
			$mapOpenTriggers.forEach($mapOpenTrigger => {
				$mapOpenTrigger.addEventListener("click", e => {
					e.preventDefault();
					this.open();
				});
			});
		}
	}

	close() {
		this.$mapOverlay.classList.remove("open");
		document.body.classList.remove("map-is-active");
		this.clearVenueEvents();
		this.backToVenueList();
		// u.gEvent("Map", "close");
	}

	open() {
		this.$mapOverlay.classList.add("open");
		document.body.classList.add("map-is-active");
		// u.gEvent("Map", "open");
	}

	selectArtwork(artworkId) {
		console.log(location);
		console.log(this.artworks);
		this.clearVenueEvents();

		this.markers.forEach(m => {
			if (m.artworkId === artworkId) {
				m.setIcon(iconSelect(m.type, true));
			} else {
				m.setIcon(iconSelect(m.type, false));
			}
		});

		this.artworks.forEach(artwork => {
			const $artworkListItem = this.$mapOverlay.querySelector(
				"[data-artwork-id='" + artwork.id + "']"
			);

			$artworkListItem.classList.remove("location-active");
			console.log($artworkListItem.dataset.artworkId, artworkId);
			if ($artworkListItem.dataset.artworkId == artworkId) {
				$artworkListItem.classList.add("location-active");
				$artworkListItem.classList.add("is-active");
				this.$details.classList.add("event-detail-active");
			}
		});
	}

	backToVenueList() {
		this.$details.classList.remove("event-detail-active");
	}

	clearVenueEvents() {
		const $activeEvent = this.$mapOverlay.querySelector(".is-active");
		const $activeMarker = this.$mapOverlay.querySelector(".location-active");
		this.markers.forEach(m => {
			m.setIcon(iconSelect(m.type, false));
		});
		if ($activeEvent) {
			$activeEvent.classList.remove("is-active");
		}
		if ($activeMarker) {
			$activeMarker.classList.remove("location-active");
		}
	}
}

function offsetCenter(map, latlng, offsetx, offsety) {
	// latlng is the apparent centre-point
	// offsetx is the distance you want that point to move to the right, in pixels
	// offsety is the distance you want that point to move upwards, in pixels
	// offset can be negative
	// offsetx and offsety are both optional
	var scale = Math.pow(2, map.getZoom());

	var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
	var pixelOffset = new google.maps.Point(
		offsetx / scale || 0,
		offsety / scale || 0
	);

	var worldCoordinateNewCenter = new google.maps.Point(
		worldCoordinateCenter.x - pixelOffset.x,
		worldCoordinateCenter.y + pixelOffset.y
	);

	var newCenter = map
		.getProjection()
		.fromPointToLatLng(worldCoordinateNewCenter);

	map.setCenter(newCenter);
}
